import React, { useEffect, useState } from 'react';
import { siteContent } from '../../data/content';
import './Hero.css';

const Hero = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  const handleCTAClick = (href) => {
    if (href.startsWith('#')) {
      const element = document.querySelector(href);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  return (
    <section id="home" className="hero">
      <div className="hero__background">
        <div className="hero__overlay"></div>
        <div className="hero__image">
          {/* Background image will be set via CSS */}
        </div>
      </div>
      
      <div className="container">
        <div className="hero__content">
          <div className={`hero__text ${isVisible ? 'hero__text--visible' : ''}`}>
            <h1 className="hero__title">
              {siteContent.hero.title}
            </h1>
            <p className="hero__subtitle">
              {siteContent.hero.subtitle}
            </p>
            <p className="hero__description">
              {siteContent.hero.description}
            </p>
            
            <div className="hero__actions">
              <a
                href={siteContent.hero.cta.primary.href}
                className="btn btn-primary btn-lg hero__cta-primary"
                onClick={(e) => {
                  e.preventDefault();
                  handleCTAClick(siteContent.hero.cta.primary.href);
                }}
              >
                {siteContent.hero.cta.primary.text}
              </a>
              {/* <a
                href={siteContent.hero.cta.secondary.href}
                className="btn btn-outline btn-lg hero__cta-secondary"
                onClick={(e) => {
                  e.preventDefault();
                  handleCTAClick(siteContent.hero.cta.secondary.href);
                }}
              >
                {siteContent.hero.cta.secondary.text}
              </a> */}
            </div>
          </div>
        </div>
      </div>
      
      {/* Scroll indicator */}
      <div className="hero__scroll-indicator">
        <div className="hero__scroll-arrow"></div>
      </div>
    </section>
  );
};

export default Hero;

